/**
 * @generated SignedSource<<f123f511a99ebcee07067ce8e0482429>>
 * @relayHash fe50508bc4b5a18ede89e45eaeb57c20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15c820aa02c9f9794ee983d498550ddbaf4ca1aec6ce6667ecb4be330c1496de

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_timelineQuery } from './src_timelineQuery.graphql';

import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: PreloadableConcreteRequest<src_timelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "15c820aa02c9f9794ee983d498550ddbaf4ca1aec6ce6667ecb4be330c1496de",
    "metadata": {},
    "name": "src_timelineQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};

export default node;
